import { MongoClient, ClientSession, Db } from "mongodb";
import { ObjectId } from "bson";
import { Buffer } from "buffer";

export class MongoHelper {
    private static get MongoInternals() {
        return Package["mongo"].MongoInternals;
    }

    public static get mongoDriver() {
        return this.MongoInternals.defaultRemoteCollectionDriver();
    }

    private static get mongoClient(): MongoClient {
        return this.mongoDriver.mongo.client;
    }

    public static get mongoDb(): Db {
        return this.mongoClient.db();
    }

    static createSession(): ClientSession {
        return this.mongoClient.startSession();
    }

    static isObjectId(objectId: string | number | ObjectId): boolean {
        return objectId && ObjectId.isValid(objectId);
    }

    static toObjectId(value: any): ObjectId {
        // console.log("toObjectID: "); console.dir(value);
        if (!value) {
            return null;
        }

        if (value instanceof ObjectId) {
            // console.log("ObjectId");
            return value;
        }

        if (value["insertedId"]) {
            // console.log("value.insertedId");
            value = value["insertedId"];
        }
        else if (value["_str"]) {
            // console.log("value['_str']");
            value = value["_str"];
        }
        else if (value["id"] instanceof Uint8Array) {
            // console.log("value['id']");
            let temp: string = "";
            value["id"].forEach(num => temp += num.toString(16).padStart(2, "0"));
            value = temp;
        }
        else if (value["_bsontype"] === "ObjectID") {
            // Ez objektum inicializáláskor kellhet.
            // console.log("_bsontype=ObjectID");
            let tmp: Uint8Array = value["id"];
            value = Buffer.from(tmp).toString("hex");
        }

        if (!ObjectId.isValid(value)) {
            return null;
        }

        // console.dir(value);
        return new ObjectId(value);
    }
}